import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { UserFieldErrorMessages } from "@constants/Errors";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import messages from "@constants/Messages";
import { handleLoginChange } from "@services/ErrorHandling";
import { USER } from "@types/user";
import { handleUserPasswordChange } from "@services/ErrorHandling";

type UserLoginInfoCardProps = {
  userData: USER;
  errors: any;
  showPassword: boolean;
  password: string;
  setShowPassword: (show: boolean) => void;
  updateUserData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
  handleOpenPasswordModal: () => void;
  createUser: boolean;
};

export const UserLoginInfoCard = ({
  userData,
  errors,
  showPassword,
  password,
  setShowPassword,
  updateUserData,
  updateError,
  handleOpenPasswordModal,
  createUser,
}: UserLoginInfoCardProps) => (
  <div>
    <TextInputField
      label={"ログインID"}
      value={userData?.login_id}
      placeholder="login_id"
      onChange={(e) =>
        handleLoginChange(e.target.value, updateUserData, updateError)
      }
      required
      disabled={!createUser}
    />
    {errors.login_id && (
      <p className="text-red-500">{UserFieldErrorMessages.loginIdError}</p>
    )}
    {errors.login_id_length && (
      <p className="text-red-500">
        {UserFieldErrorMessages.loginIdLengthError}
      </p>
    )}
    {errors.login_id_exists && (
      <p className="text-red-500">
        {UserFieldErrorMessages.loginIdExistsError}
      </p>
    )}

    <div className="mt-5 mb-5">
      <h2 className="mb-5 label-light-blue-xl">
        パスワード <span className="text-red-500">*</span>
      </h2>
      <div className="relative">
        <div>
          <input
            type={showPassword ? "text" : "password"}
            value={createUser ? password : "********************************"}
            required
            disabled={!createUser}
            readOnly={!createUser}
            className="form-text-field-border"
            onChange={(e) => {
              handleUserPasswordChange(
                "login_password",
                e.target.value,
                updateUserData,
                updateError,
              );
            }}
            autoComplete="new-password"
            name="custom-password-field"
          />
          {!createUser ? (
            <button
              type="button"
              className="ml-5 button-default-white"
              onClick={handleOpenPasswordModal}
            >
              パスワードリセット
            </button>
          ) : (
            <button
              type="button"
              className="password-eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <EyeSlashIcon className="w-6 h-6" />
              ) : (
                <EyeIcon className="w-6 h-6" />
              )}
            </button>
          )}
        </div>
      </div>
      {errors.login_password && (
        <p className="text-red-500">{UserFieldErrorMessages.passwordError}</p>
      )}
      <div className="pt-2 text-zinc-400 font-bold">{`パスワードポリシー: ${messages.generic.password_policy}`}</div>
    </div>
  </div>
);
